var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM14.4 8.25C13.9858 8.25 13.65 8.58579 13.65 9C13.65 9.41421 13.9858 9.75 14.4 9.75H15.9285L11.9727 13.0464L9.44642 11.1751C9.18122 10.9787 8.81878 10.9787 8.55358 11.1751L5.55358 13.3973C5.22074 13.6439 5.15078 14.1136 5.39733 14.4464C5.64388 14.7793 6.11358 14.8492 6.44642 14.6027L9 12.7111L11.5536 14.6027C11.8316 14.8086 12.2144 14.7976 12.4801 14.5762L17.25 10.6013V12.3333C17.25 12.7475 17.5858 13.0833 18 13.0833C18.4142 13.0833 18.75 12.7475 18.75 12.3333V9C18.75 8.58579 18.4142 8.25 18 8.25H14.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/trending-up.30fe2cdeadc7ee6c6177ba74932951a6.svg";
export { ForwardRef as ReactComponent };